import { render } from "./ReserveComplete.vue?vue&type=template&id=c8c30d76&scoped=true"
import script from "./ReserveComplete.vue?vue&type=script&lang=js"
export * from "./ReserveComplete.vue?vue&type=script&lang=js"

import "./ReserveComplete.vue?vue&type=style&index=0&id=c8c30d76&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2236819739/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8c30d76"]])

export default __exports__